import MDEditor from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';

export default function RichTextEditor({ value, onChange }) {
  return (
    <div data-color-mode="light">
      <label className="block text-sm font-medium text-brand-dark mb-2">Body</label>
      <MDEditor
        value={value || ''}
        onChange={(v) => onChange(v || '')}
        height={320}
        preview="edit"
      />
    </div>
  );
}
